var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { Box, Button, Grid, Menu, MenuItem } from '@mui/material';
import { Accordion, AccordionSummary, AccordionDetails, Typography, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SubHeader } from 'common/SubHeader';
import { DIALOG_TYPES, ERROR_MESSAGE, REGEX } from 'globals/global.constants';
import useAutoScroll from 'hooks/useAutoScroll';
import { fetchSeniorDetail, openDialog } from 'store/commonReducer/common.action';
import Goals from './goals/Goals.component';
import WellnessLeftPanel from './components/WellnessLeftPanel.component';
import WellnessRightPanel from './components/WellnessRightPanel.component';
import SeniorWellnessInfo from './SeniorWellnessInfo.component';
import { getWellnessPlan, updateWellnessPlan, RESET_WELLNESS_PLAN, } from './SeniorWellnessPlan.action';
import { INITIAL_STATE } from './wellnessPlanReducer.reducer';
import WellnessPlanProvider, { WellnessPlanContext, } from './wellnessPlanContext/WellnessPlan.context';
import { postAllGoals, postOnlyNotesData } from 'store/goals/goals.action';
import { validateDate } from 'globals/date.functions';
import moment from 'moment';
import { UPDATE_GOAL_ERROR } from './wellnessPlanContext/reducer';
import { trimValues } from 'globals/global.functions';
import { getActiveTemplates } from '../Admin/TemplateManagement/SbarDetails.action';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { PauseProvider, PausedOverlay, usePauseStatus, } from '../SeniorDashboard/PauseContext';
import { getAuditHistory } from 'common/EditAndDisable/PauseManagement.action';
var SPECIAL_CHAR_REGEX = /^[a-zA-Z0-9\s.]*$/;
var SPECIAL_CHAR_MESSAGE = 'Special characters are not allowed';
var hasInvalidCharacters = function (value) {
    return !!value && !SPECIAL_CHAR_REGEX.test(value);
};
var SeniorWellnessPlanComponent = function (_a) {
    var selectedSeniorCareGiver = _a.selectedSeniorCareGiver, setSelectedSeniorCareGiver = _a.setSelectedSeniorCareGiver, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    var dispatch = useAppDispatch();
    var _c = React.useContext(WellnessPlanContext), state = _c.state, dispatchContext = _c.dispatchContext;
    var _d = React.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var _e = React.useState([]), templates = _e[0], setTemplates = _e[1];
    var _f = useState([]), sbarTemplates = _f[0], setSbarTemplates = _f[1];
    var handleTemplateMenu = function (event) {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    var handleTemplateClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var _g = React.useState(false), apiLoaded = _g[0], setApiLoaded = _g[1];
    var _h = useAutoScroll(), ref = _h.ref, scrollToFirstError = _h.scrollToFirstError;
    var autoToggleDoneRef = React.useRef(false);
    var wellnessData = useAppSelector(function (state) { return state.wellnessPlan; });
    var tableData = useAppSelector(function (state) { return state.goals.goalsRowsData; });
    var goalsActionMap = useAppSelector(function (state) { return state.goals.goalsActionMap; });
    var seniorId = useAppSelector(function (state) { return state.common.seniorDetail.minimalInfo.user_id; });
    var _j = React.useState(false), showWellnessPlan = _j[0], setShowWellnessPlan = _j[1];
    var _k = React.useState(true), isPriorityAccordionOpen = _k[0], setIsPriorityAccordionOpen = _k[1];
    var _l = React.useState(0), sbarSaveCount = _l[0], setSbarSaveCount = _l[1];
    var isProfilePaused = usePauseStatus().isProfilePaused;
    var _m = React.useState(INITIAL_STATE.wellnessPlanDetail), leftField = _m[0], setLeftField = _m[1];
    var _o = React.useState(INITIAL_STATE.memberPriority), memberPriority = _o[0], setMemberPriority = _o[1];
    var _p = React.useState(INITIAL_STATE.challenges), challenges = _p[0], setChallenges = _p[1];
    var isRightAccordionDataEmpty = !memberPriority.some(function (item) { return (item === null || item === void 0 ? void 0 : item.value.trim()) !== ''; }) &&
        !challenges.some(function (item) { return (item === null || item === void 0 ? void 0 : item.value.trim()) !== ''; });
    var _q = React.useState(true), isSaveButtonDisabled = _q[0], setIsSaveButtonDisabled = _q[1];
    React.useEffect(function () {
        if (!seniorId) {
            dispatch(fetchSeniorDetail());
        }
    }, [dispatch, seniorId]);
    React.useEffect(function () {
        if (selectedSeniorCareGiver === null || selectedSeniorCareGiver === void 0 ? void 0 : selectedSeniorCareGiver.value) {
            dispatch({ type: RESET_WELLNESS_PLAN });
            setApiLoaded(false);
            dispatch(getWellnessPlan(selectedSeniorCareGiver.value)).finally(function () {
                return setApiLoaded(true);
            });
        }
    }, [dispatch, selectedSeniorCareGiver === null || selectedSeniorCareGiver === void 0 ? void 0 : selectedSeniorCareGiver.value]);
    React.useEffect(function () {
        return function () {
            dispatch({ type: RESET_WELLNESS_PLAN });
        };
    }, [dispatch]);
    React.useEffect(function () {
        setShowWellnessPlan(wellnessData.currentVersion ? true : false);
        setLeftField(wellnessData.wellnessPlanDetail);
        setMemberPriority(wellnessData.memberPriority);
        setChallenges(wellnessData.challenges);
    }, [wellnessData]);
    React.useEffect(function () {
        if (!showWellnessPlan)
            return;
        if (autoToggleDoneRef.current)
            return;
        var hasMemberPriorityData = memberPriority.some(function (item) { return item.value.trim() !== ''; });
        var hasChallengesData = challenges.some(function (item) { return item.value.trim() !== ''; });
        setIsPriorityAccordionOpen(!(hasMemberPriorityData || hasChallengesData));
        autoToggleDoneRef.current = true;
    }, [showWellnessPlan, memberPriority, challenges]);
    var compareData = React.useCallback(function () {
        var rowsData = __spreadArray(__spreadArray([], state.goalsRowsData, true), state.deleteRowsData, true).map(function (rowData) {
            var isEdited = rowData.isEdited, rest = __rest(rowData, ["isEdited"]);
            return rest;
        });
        if (JSON.stringify(leftField) ==
            JSON.stringify(wellnessData.wellnessPlanDetail) &&
            JSON.stringify(memberPriority) ==
                JSON.stringify(wellnessData.memberPriority) &&
            JSON.stringify(challenges) == JSON.stringify(wellnessData.challenges) &&
            JSON.stringify(rowsData) === JSON.stringify(tableData)) {
            return false;
        }
        return true;
    }, [
        challenges,
        leftField,
        memberPriority,
        state.deleteRowsData,
        state.goalsRowsData,
        tableData,
        wellnessData.challenges,
        wellnessData.memberPriority,
        wellnessData.wellnessPlanDetail,
    ]);
    var checkGoalsError = function () {
        var isError = false;
        var data = state.goalsRowsData.map(function (data) {
            if (!data.goalType) {
                isError = true;
                data.goalTypeError = true;
                data.goalTypeErrorText = ERROR_MESSAGE.REQUIRED_FIELD;
                return data;
            }
            if (!data.goal) {
                isError = true;
                data.goalError = true;
                data.goalErrorText = ERROR_MESSAGE.REQUIRED_FIELD;
                return data;
            }
            if (!data.action) {
                isError = true;
                data.actionError = true;
                data.actionErrorText = ERROR_MESSAGE.REQUIRED_FIELD;
                return data;
            }
            if (data.startDate && !validateDate(data.startDate)) {
                isError = true;
                return data;
            }
            if (data.targetDate && !validateDate(data.targetDate)) {
                isError = true;
                return data;
            }
            if (Math.sign(moment(data.targetDate).diff(data.startDate)) === -1) {
                isError = true;
                return data;
            }
            return data;
        });
        if (isError) {
            dispatchContext({ type: UPDATE_GOAL_ERROR, payload: data });
        }
        return isError;
    };
    React.useEffect(function () {
        var hasGoalsData = state.goalsRowsData.some(function (goal) { return goal.goal.trim() !== '' || goal.action.trim() !== ''; });
        var hasLeftPanelData = Object.values(leftField).some(function (field) { return field.value.trim() !== ''; });
        var hasMemberPriorityData = memberPriority.some(function (item) { return item.value.trim() !== ''; });
        var hasChallengesData = challenges.some(function (item) { return item.value.trim() !== ''; });
        var isFilled = hasLeftPanelData || hasMemberPriorityData || hasChallengesData || hasGoalsData;
        setIsSaveButtonDisabled(!isFilled || !compareData());
    }, [leftField, memberPriority, challenges, state.goalsRowsData, compareData]);
    var isCustomGoalRow = React.useCallback(function (goal) {
        var _a;
        if (goal.isCustomGoal)
            return true;
        if (!goal.goalType || !goal.goal || !goal.action)
            return false;
        var goalTypeMap = goalsActionMap === null || goalsActionMap === void 0 ? void 0 : goalsActionMap[goal.goalType];
        if (!goalTypeMap || !goalTypeMap.actions)
            return true;
        var goalExists = Object.values(goalTypeMap.actions).some(function (item) { var _a; return ((_a = item.goalName) !== null && _a !== void 0 ? _a : item.actionName) === goal.goal; });
        if (!goalExists)
            return true;
        var subActions = ((_a = goalTypeMap.actions[goal.goal]) === null || _a === void 0 ? void 0 : _a.subActions) || {};
        var actionExists = Object.values(subActions).some(function (item) { return item.actionName === goal.action; });
        return !actionExists;
    }, [goalsActionMap]);
    React.useEffect(function () {
        var fetchSbarTemplates = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, dispatch(getActiveTemplates({
                                template_type: 'SBAR',
                                template_category: 'Wellness Plan',
                            }))];
                    case 1:
                        response = _a.sent();
                        setSbarTemplates((response === null || response === void 0 ? void 0 : response.data) || []);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchSbarTemplates();
    }, [dispatch]);
    var handleSbarTemplateSelect = function (template) {
        dispatch(openDialog({
            type: DIALOG_TYPES.ADMIN_ACTION_DIALOG,
            firstMessage: 'Applying another template will replace the current SBAR content.',
            secondMessage: ' Continue?',
            successButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            isFailButton: true,
            onSuccessButton: function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, templateContent_1, error_2;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, dispatch(getActiveTemplates({
                                    template_id: template.template_id,
                                    version: template.version,
                                    template_type: template.template_type,
                                    template_category: 'Wellness Plan',
                                }))];
                        case 1:
                            response = _b.sent();
                            templateContent_1 = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.template_content;
                            if (!templateContent_1)
                                return [2 /*return*/];
                            setLeftField(function (prev) {
                                var _a, _b, _c, _d;
                                return (__assign(__assign({}, prev), { situation: __assign(__assign({}, prev.situation), { value: ((_a = templateContent_1.situation) === null || _a === void 0 ? void 0 : _a.S) ||
                                            templateContent_1.situation ||
                                            '', error: false, errorText: '' }), background: __assign(__assign({}, prev.background), { value: ((_b = templateContent_1.background) === null || _b === void 0 ? void 0 : _b.S) ||
                                            templateContent_1.background ||
                                            '', error: false, errorText: '' }), assessment: __assign(__assign({}, prev.assessment), { value: ((_c = templateContent_1.assessment) === null || _c === void 0 ? void 0 : _c.S) ||
                                            templateContent_1.assessment ||
                                            '', error: false, errorText: '' }), recommendation: __assign(__assign({}, prev.recommendation), { value: ((_d = templateContent_1.recommendation) === null || _d === void 0 ? void 0 : _d.S) ||
                                            templateContent_1.recommendation ||
                                            '', error: false, errorText: '' }) }));
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _b.sent();
                            console.error(error_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
        }));
    };
    React.useEffect(function () {
        var fetchTemplates = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, dispatch(getActiveTemplates({
                                template_type: 'Priorities and Challenges',
                                template_category: 'Wellness Plan',
                            }))];
                    case 1:
                        response = _a.sent();
                        setTemplates((response === null || response === void 0 ? void 0 : response.data) || []);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchTemplates();
    }, [dispatch]);
    var handleTemplateSelect = function (template) {
        dispatch(openDialog({
            type: DIALOG_TYPES.ADMIN_ACTION_DIALOG,
            firstMessage: 'Applying another template will replace the current Priority and Challenge content.',
            secondMessage: ' Continue?',
            successButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            isFailButton: true,
            onSuccessButton: function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, content, priority, challenge, error_4;
                var _a, _b, _c, _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            _h.trys.push([0, 2, , 3]);
                            handleTemplateClose();
                            return [4 /*yield*/, dispatch(getActiveTemplates({
                                    template_id: template.template_id,
                                    version: template.version,
                                    template_type: template.template_type,
                                    template_category: 'Wellness Plan',
                                }))];
                        case 1:
                            response = _h.sent();
                            content = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.template_content;
                            if (!content)
                                return [2 /*return*/];
                            priority = (_d = (_c = (_b = content.priority) === null || _b === void 0 ? void 0 : _b.S) !== null && _c !== void 0 ? _c : content.priority) !== null && _d !== void 0 ? _d : [];
                            challenge = (_g = (_f = (_e = content.challenge) === null || _e === void 0 ? void 0 : _e.S) !== null && _f !== void 0 ? _f : content.challenge) !== null && _g !== void 0 ? _g : [];
                            setMemberPriority((Array.isArray(priority)
                                ? priority
                                : [priority]).map(function (value, index) { return ({
                                seq: index + 1,
                                value: typeof value === 'string' ? value : '',
                                error: false,
                                errorText: '',
                            }); }));
                            setChallenges((Array.isArray(challenge)
                                ? challenge
                                : [challenge]).map(function (value, index) { return ({
                                seq: index + 1,
                                value: typeof value === 'string' ? value : '',
                                error: false,
                                errorText: '',
                            }); }));
                            return [3 /*break*/, 3];
                        case 2:
                            error_4 = _h.sent();
                            console.error(error_4);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
        }));
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isError, isNextVersion, goalsError, trimmedGoalsRowsData, trimmedDeleteRowsData, trimmedLeftField, trimmedMemberPriority, trimmedChallenges, notesChanged, notesUpdates, notesChangedIndex, index, element, diff, localNotesChanged, key, index, itemIndex, tableRow, goalRow, normalGoalsRowsData, customGoalsRowsData, normalDeleteRowsData, customDeleteRowsData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isProfilePaused || readOnly) {
                        return [2 /*return*/];
                    }
                    isError = false;
                    Object.entries(leftField).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (!REGEX.BLANK_FIELD.test(value.value)) {
                            isError = true;
                            setLeftField(function (prevState) {
                                var _a;
                                return (__assign(__assign({}, prevState), (_a = {}, _a[key] = __assign(__assign({}, prevState[key]), { error: true, errorText: ERROR_MESSAGE.REQUIRED_FIELD }), _a)));
                            });
                        }
                        else if (hasInvalidCharacters(value.value)) {
                            isError = true;
                            setLeftField(function (prevState) {
                                var _a;
                                return (__assign(__assign({}, prevState), (_a = {}, _a[key] = __assign(__assign({}, prevState[key]), { error: true, errorText: SPECIAL_CHAR_MESSAGE }), _a)));
                            });
                        }
                    });
                    setMemberPriority(memberPriority.map(function (data) {
                        if (!REGEX.BLANK_FIELD.test(data.value)) {
                            isError = true;
                            return __assign(__assign({}, data), { error: true, errorText: ERROR_MESSAGE.REQUIRED_FIELD });
                        }
                        if (hasInvalidCharacters(data.value)) {
                            isError = true;
                            return __assign(__assign({}, data), { error: true, errorText: SPECIAL_CHAR_MESSAGE });
                        }
                        return data;
                    }));
                    setChallenges(challenges.map(function (data) {
                        if (!REGEX.BLANK_FIELD.test(data.value)) {
                            isError = true;
                            return __assign(__assign({}, data), { error: true, errorText: ERROR_MESSAGE.REQUIRED_FIELD });
                        }
                        if (hasInvalidCharacters(data.value)) {
                            isError = true;
                            return __assign(__assign({}, data), { error: true, errorText: SPECIAL_CHAR_MESSAGE });
                        }
                        return data;
                    }));
                    isNextVersion = compareData();
                    goalsError = checkGoalsError();
                    if (isError || goalsError || !isNextVersion) {
                        scrollToFirstError();
                        return [2 /*return*/];
                    }
                    trimmedGoalsRowsData = trimValues(state.goalsRowsData);
                    trimmedDeleteRowsData = trimValues(state.deleteRowsData);
                    trimmedLeftField = trimValues(leftField);
                    trimmedMemberPriority = trimValues(memberPriority);
                    trimmedChallenges = trimValues(challenges);
                    notesChanged = false;
                    notesUpdates = [];
                    notesChangedIndex = [];
                    for (index = 0; index < tableData.length; index++) {
                        element = tableData[index];
                        diff = trimmedGoalsRowsData[index];
                        if (!element || !diff)
                            continue;
                        localNotesChanged = false;
                        for (key in element) {
                            if (key === 'resource')
                                continue;
                            if (key === 'notes' && diff.notes !== element.notes) {
                                localNotesChanged = true;
                            }
                            if (key !== 'notes' && element[key] !== diff[key]) {
                                localNotesChanged = false;
                                break;
                            }
                        }
                        if (localNotesChanged) {
                            notesChanged = true;
                            notesChangedIndex.push(index);
                        }
                    }
                    if (!notesChanged) return [3 /*break*/, 2];
                    for (index = 0; index < notesChangedIndex.length; index++) {
                        itemIndex = notesChangedIndex[index];
                        tableRow = tableData[itemIndex];
                        goalRow = trimmedGoalsRowsData[itemIndex];
                        if (!tableRow || !goalRow)
                            continue;
                        notesUpdates.push({
                            id: tableRow.id,
                            notes: goalRow.notes,
                            currentVersion: goalRow.current_version,
                            caregiverId: selectedSeniorCareGiver.value,
                        });
                    }
                    return [4 /*yield*/, Promise.all(notesUpdates.map(function (_a) {
                            var id = _a.id, notes = _a.notes, currentVersion = _a.currentVersion, caregiverId = _a.caregiverId;
                            return dispatch(postOnlyNotesData(notes, id, currentVersion, caregiverId, state.goalsFilter));
                        }))];
                case 1:
                    _a.sent();
                    setSbarSaveCount(function (prev) { return prev + 1; });
                    setIsPriorityAccordionOpen(false);
                    return [2 /*return*/];
                case 2:
                    if (!(trimmedGoalsRowsData.length || Object.keys(trimmedLeftField).length)) return [3 /*break*/, 5];
                    dispatch(updateWellnessPlan(trimmedLeftField, trimmedMemberPriority, trimmedChallenges, isNextVersion, selectedSeniorCareGiver));
                    normalGoalsRowsData = trimmedGoalsRowsData.filter(function (g) { return !isCustomGoalRow(g); });
                    customGoalsRowsData = trimmedGoalsRowsData.filter(function (g) { return isCustomGoalRow(g); });
                    normalDeleteRowsData = trimmedDeleteRowsData.filter(function (g) { return !isCustomGoalRow(g); });
                    customDeleteRowsData = trimmedDeleteRowsData.filter(function (g) { return isCustomGoalRow(g); });
                    if (!(trimmedGoalsRowsData.length > 0 || trimmedDeleteRowsData.length > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(postAllGoals(selectedSeniorCareGiver, normalGoalsRowsData, normalDeleteRowsData, customGoalsRowsData, customDeleteRowsData, state.goalsFilter))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setSbarSaveCount(function (prev) { return prev + 1; });
                    setIsPriorityAccordionOpen(false);
                    _a.label = 5;
                case 5:
                    scrollToFirstError();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Box, { "data-testid": 'senior-wellness-plan', children: [_jsx(SubHeader, {}), _jsx(SeniorWellnessInfo, { selectedSeniorCareGiver: selectedSeniorCareGiver, setSelectedSeniorCareGiver: setSelectedSeniorCareGiver }), _jsx(PausedOverlay, { disabled: isProfilePaused, children: _jsx(Box, { ref: ref, children: showWellnessPlan ? (_jsx(_Fragment, { children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, sm: 12, md: 5, lg: 5, children: _jsx(WellnessLeftPanel, { data: leftField, setData: setLeftField, collapseAfterSave: sbarSaveCount, templates: sbarTemplates, onTemplateSelect: handleSbarTemplateSelect, readOnly: readOnly }) }), _jsx(Grid, { item: true, xs: 12, sm: 12, md: 7, lg: 7, children: _jsx(Box, { sx: { mt: 3 }, children: _jsxs(Accordion, { expanded: isPriorityAccordionOpen, onChange: function (_, isExpanded) {
                                                if (!isRightAccordionDataEmpty) {
                                                    setIsPriorityAccordionOpen(isExpanded);
                                                }
                                            }, style: {
                                                borderRadius: '15px',
                                            }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', mr: 2, children: [_jsx(Typography, { variant: 'h6', fontWeight: 500, children: "Priorities & Challenges" }), _jsx(Button, { variant: 'contained', disabled: readOnly, startIcon: _jsx(DescriptionOutlinedIcon, {}), endIcon: _jsx(KeyboardArrowDownIcon, {}), onClick: handleTemplateMenu, children: "Templates" })] }) }), _jsxs(AccordionDetails, { children: [_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 3, children: [_jsx(WellnessRightPanel, { name: 'memberPriority', item: memberPriority, updateItem: setMemberPriority, cardTitle: 'Priorities', inputPlaceholder: 'Please enter priority here', buttonLabel: 'Add Priority', readOnly: readOnly }), _jsx(WellnessRightPanel, { name: 'challenges', item: challenges, updateItem: setChallenges, cardTitle: 'Challenges', inputPlaceholder: 'Please enter challenge here', buttonLabel: 'Add Challenge', readOnly: readOnly })] }), _jsx(Menu, { anchorEl: anchorEl, open: open, onClose: handleTemplateClose, PaperProps: {
                                                                sx: {
                                                                    width: 'fit-content',
                                                                    mt: 1,
                                                                    borderRadius: 2,
                                                                    boxShadow: '0px 4px 20px rgba(0,0,0,0.15)',
                                                                    p: 1,
                                                                },
                                                            }, children: templates.length ? (__spreadArray([], templates, true).sort(function (a, b) {
                                                                return (a.template_name || '').localeCompare(b.template_name || '', undefined, { sensitivity: 'base' });
                                                            })
                                                                .map(function (template) { return (_jsx(MenuItem, { onClick: function () { return handleTemplateSelect(template); }, children: template.template_name }, template.template_id)); })) : (_jsx(MenuItem, { disabled: true, sx: { justifyContent: 'center' }, children: "No Templates Found" })) })] })] }) }) })] }) })) : (_jsx(Box, { style: {
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                            marginTop: '80px',
                        }, children: _jsx(Button, { variant: 'contained', color: 'primary', size: 'large', disabled: isProfilePaused || readOnly, onClick: function () { return setShowWellnessPlan(true); }, style: { width: '256px' }, children: "Add New Wellness Plan" }) })) }) }), showWellnessPlan && (_jsx(Goals, { customerID: selectedSeniorCareGiver.value, selectedSeniorCareGiver: selectedSeniorCareGiver, readOnly: readOnly, disabled: isProfilePaused })), showWellnessPlan && !readOnly && (_jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '2em 0', children: _jsx(Button, { "data-testid": 'handle-save', variant: 'contained', color: 'primary', size: 'large', disabled: isSaveButtonDisabled ||
                        !wellnessData.isLatestVersion ||
                        isProfilePaused, onClick: handleSave, children: "Save" }) }))] }));
};
var SeniorWellnessPlanWithPause = function (_a) {
    var _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    var dispatch = useAppDispatch();
    var _c = React.useState({ value: '', label: '' }), selectedSeniorCareGiver = _c[0], setSelectedSeniorCareGiver = _c[1];
    var _d = React.useState(null), auditInfo = _d[0], setAuditInfo = _d[1];
    React.useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getAuditHistory())];
                    case 1:
                        info = _a.sent();
                        setAuditInfo(info);
                        return [2 /*return*/];
                }
            });
        }); };
        run();
    }, [dispatch, selectedSeniorCareGiver === null || selectedSeniorCareGiver === void 0 ? void 0 : selectedSeniorCareGiver.value]);
    return (_jsx(PauseProvider, { auditInfo: auditInfo, children: _jsx(SeniorWellnessPlanComponent, { selectedSeniorCareGiver: selectedSeniorCareGiver, setSelectedSeniorCareGiver: setSelectedSeniorCareGiver, readOnly: readOnly }) }));
};
var SeniorWellnessPlan = function (_a) {
    var _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    return (_jsx(WellnessPlanProvider, { children: _jsx(SeniorWellnessPlanWithPause, { readOnly: readOnly }) }));
};
export default SeniorWellnessPlan;
